import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box, Typography, Button, Grid, Card, CardContent,
  Rating, Avatar, Container
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StarIcon from '@mui/icons-material/Star';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AnimatedSection from '../components/AnimatedSection';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import DiamondIcon from '@mui/icons-material/Diamond';
import "@fontsource/playfair-display";
import { Link } from 'react-router-dom';
import OffersSlider from '../components/OffersSlider';
import MainHeroSlider from '../components/MainHeroSlider';

const services = [
  {
    icon: <ContentCutIcon />,
    title: 'Hair Styling',
    desc: 'Cuts, colours, keratin & more',
    bg: '#fff0f7',
    img: '/assets/hairdresser-woman-weaving-braid-hair-wedding-styling.jpeg',
  },
  {
    icon: <AutoAwesomeIcon />,
    title: 'Skin & Facials',
    desc: 'Luxury facials & skin treatments',
    bg: '#fff0f7',
    img: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&q=80',
  },
  {
    icon: <FavoriteBorderIcon />,
    title: 'Nail Care',
    desc: 'Manicure, pedicure & nail art',
    bg: '#fff0f7',
    img: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400&q=80',
  },
  {
    icon: <LoyaltyIcon />,
    title: 'Bridal Makeup',
    desc: 'Complete bridal packages',
    bg: '#fff0f7',
    img: '/assets/bridal.jpeg',
  },
  {
    icon: <FavoriteBorderIcon />,
    title: 'Massages',
    desc: 'Relax, refresh & rejuvenate',
    bg: '#fff0f7',
    img: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=400&q=80',
  },
  {
    icon: <ContentCutIcon />,
    title: "Men's Grooming",
    desc: 'Premium grooming services',
    bg: '#fff0f7',
    img: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400&q=80',
  },
];

const testimonials = [
  {
    name: 'Chiriki Satyavathi',
    stars: 5,
    text: `Really had a great experience. Got my first haircut was really nervous but the service was so incredible. Kalyan bro was friendly and interactive Much satisfied with the service Would highly recommenAbsolutely love the bridal package! The team made me feel like a queen on my special day.Highly recommend Splash for any bride- to - be.`
  },
  {
    name: 'Ramya Reddy',
    stars: 5,
    text: "Really happy with the service. Mounika was kind and patient, and they made sure I was comfortable throughout. The results turned out exactly how I wanted. Would definitely recommend this place to my friends and family.",
  },
  {
    name: 'Usha Kiranmai',
    stars: 5,
    text: "I had a very good experience at this parlour. The beautician(Sashikala garu❤️) did an excellent job and was very professional, polite, and patient. The service was neat and I am really happy with the results. Highly recommende"
  },
  {
    name: 'Kavitha Rani',
    stars: 5,
    text: "I'm Kavitha... Today I visited splash Beauty lounge.. The service was extraordinary and given good service by Ms. Vijaya garu... Really good And Really I want to visit again and sure Thank you",
  },
  {
    name: 'Hemareddy Sangati',
    stars: 5,
    text: "I visted first tym, but the service is amazing. For me yamuna mam took over everything. Its great thank you so much..",
  },

  {
    name: 'Danga Anu',
    stars: 5,
    text: "I have a fantastic experience with splash beauty lounge 4999 PKG highly recommend mounica Head massage and hair cuts done by Ashok thank you splash",
  },

];

const features = [
  { icon: <StarBorderIcon />, title: 'Expert Stylists', desc: 'Trained professionals with years of experience in the latest beauty trends' },
  { icon: <AutoAwesomeIcon />, title: 'Premium Products', desc: "We use only top-quality brands like L'Oreal, Schwarzkopf & more" },
  { icon: <DiamondIcon />, title: 'Luxury Experience', desc: 'Relax in our elegant, hygienic & comfortable beauty lounge' },
];

export default function HomePage() {
  return (
    <Box>
      <Helmet>
        <title>Best Beauty Salon in Vizag | Splash Beauty Lounge Asilmetta</title>
        <meta name="description" content="Splash Beauty Lounge is the best unisex salon in Vizag offering hair, skin, bridal makeup, weight loss and laser hair removal services." />
        <meta name="keywords" content="best salon in Vizag, beauty parlour in Vizag, unisex salon Vizag, bridal makeup Vizag, hair salon Asilmetta, skin clinic Vizag,permanent hair removal Vizag, weight loss treatments Vizag, beauty salon near me, hair treatments Vizag" />
      </Helmet>
      {/* Hero */}
      <Box
        sx={{
          position: 'relative',
          height: {
            xs: '35vh',    // Mobile
            sm: '50vh',    // Small tablets
            md: '65vh',    // Large tablets / 1024px screens
            lg: '85vh'     // Large desktops
          },
          overflow: 'hidden',
          backgroundColor: '#1a1a1a',
        }}
      >
        <MainHeroSlider />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.1) 100%)',
            zIndex: 1,
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            px: 2, // Less padding on mobile
            pointerEvents: 'none',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 1.5, md: 2 },
              flexWrap: 'wrap',    // Allow wrap for safety
              justifyContent: 'center',
              mt: 'auto',
              mb: { xs: 3, md: 4 },
              animation: 'fadeUp 0.8s ease 0.7s both',
              pointerEvents: 'auto',
            }}
          >
            <Button
              component="a"
              href="tel:8977626223"
              variant="contained"
              startIcon={<PhoneIcon sx={{ fontSize: { xs: '1rem', md: 'inherit' } }} />}
              sx={{
                backgroundColor: '#FF0099',
                color: '#fff',
                borderRadius: '25px',
                px: { xs: 1.5, md: 3, lg: 5 },
                py: { xs: 0.8, md: 1.2, lg: 1.5 },
                fontSize: { xs: '0.75rem', md: '0.9rem', lg: '1rem' },
                fontWeight: 700,
                whiteSpace: 'nowrap',
                '&:hover': { backgroundColor: '#CC0077' },
                boxShadow: '0 4px 15px rgba(255,0,153,0.4)',
              }}
            >
              Book Now
            </Button>
            <Link to='/services#bridal' style={{ textDecoration: 'none' }}>
              <Button
                variant="outlined"
                endIcon={<ArrowForwardIcon sx={{ fontSize: { xs: '1rem', md: 'inherit' } }} />}
                sx={{
                  borderColor: '#fff',
                  color: '#fff',
                  borderWidth: { xs: '1px', md: '2px' },
                  borderRadius: '25px',
                  px: { xs: 1.5, md: 3, lg: 5 },
                  py: { xs: 0.8, md: 1.2, lg: 1.5 },
                  fontSize: { xs: '0.75rem', md: '0.9rem', lg: '1rem' },
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  backdropFilter: 'blur(5px)',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    borderColor: '#FF0099',
                    color: '#fff',
                    backgroundColor: '#FF0099'
                  },
                }}
              >
                Services
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>

      {/* What We Offer */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <AnimatedSection>
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography
              sx={{
                fontFamily: '"Lato", sans-serif',
                fontSize: '0.75rem',
                color: '#FF0099',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                mb: 1,
              }}
            >
              OUR SERVICES
            </Typography>
            <Typography variant="h3" sx={{ color: '#1a1a1a', fontSize: { xs: '1.8rem', md: '2.2rem' } }}>
              What We Offer
            </Typography>
          </Box>
        </AnimatedSection>

        <Grid container spacing={3}>
          {services.map((s, i) => (
            <Grid item xs={12} sm={6} md={4} key={s.title}>
              <AnimatedSection delay={i * 0.1}>
                <Card
                  elevation={0}
                  sx={{
                    border: '1px solid #f0f0f0',
                    borderRadius: 2,
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 10px 30px rgba(255,0,153,0.1)',
                    },
                    cursor: 'pointer',
                  }}
                >
                  <Box
                    sx={{
                      height: 180,
                      backgroundImage: `url(${s.img})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  />
                  <CardContent sx={{ pt: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          borderRadius: '50%',
                          backgroundColor: '#FF0099',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.9rem',
                          color: '#fff'
                        }}
                      >
                        {s.icon}
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{ fontFamily: '"Playfair Display", serif', fontSize: '1rem', color: '#1a1a1a' }}
                      >
                        {s.title}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.82rem', color: '#888', ml: 5 }}
                    >
                      {s.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Why Choose Us */}
      <Box sx={{ backgroundColor: '#fafafa', py: 8 }}>
        <Container maxWidth="lg">
          <AnimatedSection>
            <Box sx={{ textAlign: 'center', mb: 5 }}>
              <Typography
                sx={{
                  fontFamily: '"Lato", sans-serif',
                  fontSize: '0.75rem',
                  color: '#FF0099',
                  letterSpacing: '0.25em',
                  textTransform: 'uppercase',
                  mb: 1,
                }}
              >
                WHY CHOOSE US
              </Typography>
              <Typography variant="h3" sx={{ color: '#1a1a1a', fontSize: { xs: '1.8rem', md: '2.2rem' } }}>
                The Splash Experience
              </Typography>
            </Box>
          </AnimatedSection>
          <Grid container spacing={4} justifyContent="center">
            {features.map((f, i) => (
              <Grid item xs={12} sm={4} key={f.title}>
                <AnimatedSection delay={i * 0.15}>
                  <Box sx={{ textAlign: 'center', p: 3 }}>
                    <Box
                      sx={{
                        width: 70,
                        height: 70,
                        borderRadius: '50%',
                        backgroundColor: '#FF0099',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '26px',
                        mx: 'auto',
                        mb: 2,
                        boxShadow: '0 4px 20px rgba(255,0,153,0.3)',
                        color: '#fff'
                      }}
                    >
                      {f.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{ fontFamily: '"Playfair Display", serif', mb: 1, color: '#1a1a1a' }}
                    >
                      {f.title}
                    </Typography>
                    <Typography
                      sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.85rem', color: '#888', lineHeight: 1.6 }}
                    >
                      {f.desc}
                    </Typography>
                  </Box>
                </AnimatedSection>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Offers Section */}
      <OffersSlider />

      {/* Testimonials */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <AnimatedSection>
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography
              sx={{
                fontFamily: '"Lato", sans-serif',
                fontSize: '0.75rem',
                color: '#FF0099',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                mb: 1,
              }}
            >
              TESTIMONIALS
            </Typography>
            <Typography variant="h3" sx={{ color: '#1a1a1a', fontSize: { xs: '1.8rem', md: '2.2rem' } }}>
              What Our Clients Say
            </Typography>
          </Box>
        </AnimatedSection>
        <Grid container spacing={3}>
          {testimonials.map((t, i) => (
            <Grid item xs={12} sm={6} md={4} key={t.name} sx={{ display: 'flex' }}>
              <AnimatedSection delay={i * 0.08} sx={{ display: 'flex', width: '100%' }}>
                <Box
                  sx={{
                    border: '1px solid #f0f0f0',
                    borderRadius: 2,
                    p: 3,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'box-shadow 0.3s',
                    '&:hover': { boxShadow: '0 6px 20px rgba(255,0,153,0.08)' },
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                    <Rating
                      value={t.stars}
                      readOnly
                      size="small"
                      sx={{ color: '#FF0099' }}
                      icon={<StarIcon fontSize="inherit" />}
                      emptyIcon={<StarIcon fontSize="inherit" />}
                    />
                    <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '1.2rem', color: '#ddd' }}>
                      "
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: '"Lato", sans-serif',
                      fontSize: '0.85rem',
                      color: '#555',
                      lineHeight: 1.7,
                      mb: 2,
                      fontStyle: 'italic',
                      flexGrow: 1,
                    }}
                  >
                    {t.text}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 'auto' }}>
                    <Avatar
                      sx={{
                        width: 36,
                        height: 36,
                        backgroundColor: '#FF0099',
                        fontSize: '0.9rem',
                        fontFamily: '"Lato", sans-serif',
                        fontWeight: 700,
                      }}
                    >
                      {t.name[0]}
                    </Avatar>
                    <Typography
                      sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, fontSize: '0.85rem', color: '#333' }}
                    >
                      {t.name}
                    </Typography>
                  </Box>
                </Box>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* CTA Banner */}
      <AnimatedSection>
        <Box
          sx={{
            backgroundColor: '#FF0099',
            py: 7,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              mb: 1.5,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Ready for a Transformation?
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.9)',
              mb: 3.5,
              fontSize: '0.95rem',
            }}
          >
            Book your appointment today and let our experts bring out the best version of you.
          </Typography>
          <Button
            component="a"
            href="tel:8977626223"
            variant="contained"
            startIcon={<PhoneIcon />}
            sx={{
              backgroundColor: '#fff',
              color: '#FF0099',
              borderRadius: '25px',
              px: 4,
              py: 1.3,
              fontSize: '0.9rem',
              fontWeight: 700,
              '&:hover': { backgroundColor: '#f5f5f5' },
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
          >
            Call +91 89776 26223
          </Button>
        </Box>
      </AnimatedSection>

      {/* Map / Location */}
      <Container maxWidth="lg" sx={{ py: 7 }}>
        <AnimatedSection>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography
              sx={{
                fontFamily: '"Lato", sans-serif',
                fontSize: '0.75rem',
                color: '#FF0099',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                mb: 1,
              }}
            >
              VISIT US
            </Typography>
            <Typography variant="h5" sx={{ color: '#1a1a1a', fontFamily: '"Playfair Display", serif' }}>
              Find Us Here
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 4 }}>
            <LocationOnIcon sx={{ color: '#FF0099' }} />
            <Typography sx={{ fontFamily: '"Lato", sans-serif', color: '#555', fontSize: '0.95rem' }}>
              Opp. Bombay Gaslight Stores, Asilmetta Junction, Visakhapatnam
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              height: { xs: '300px', md: '450px' },
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              border: '1px solid #eee',
            }}
          >
            <iframe
              title="Splash Beauty Lounge Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.0637174620584!2d83.3031023!3d17.7204481!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3943477815d9cf%3A0x6a0e63712d9f4851!2sSplash%20Beauty%20Lounge!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Box>
        </AnimatedSection>
      </Container>
    </Box>
  );
}